import React, { useState, useRef, useEffect } from 'react';
import { Download, ChevronDown, FileText, Store, Megaphone, Loader2 } from 'lucide-react';

// Collapses the secondary export / tool actions (CSV, eBay, LitCommerce, AI
// social posts) into a single dropdown so the primary actions stay prominent.
export default function ProductsExportMenu({
  onExportCsv, onExportEbay, onExportLitCommerce, onAiPosts, aiPosting, disabled,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  const items = [
    { label: 'Export CSV', icon: FileText, onClick: onExportCsv },
    { label: 'eBay CSV', icon: Store, onClick: onExportEbay },
    { label: 'LitCommerce CSV', icon: Download, onClick: onExportLitCommerce },
  ];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        disabled={disabled}
        className="flex items-center gap-2 bg-white/5 hover:bg-white/10 border border-white/10 disabled:opacity-40 text-white font-bold text-xs tracking-wider px-4 py-3 transition-colors"
      >
        <Download className="w-4 h-4" /> EXPORT & TOOLS <ChevronDown className="w-3 h-3" />
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-56 bg-[#111115] border border-white/10 shadow-xl z-30">
          {items.map((it) => (
            <button
              key={it.label}
              onClick={() => { setOpen(false); it.onClick(); }}
              className="w-full flex items-center gap-2 px-4 py-2.5 text-white/70 hover:text-white hover:bg-white/5 text-xs font-bold tracking-wider transition-colors text-left"
            >
              <it.icon className="w-3.5 h-3.5" /> {it.label}
            </button>
          ))}
          <div className="border-t border-white/5" />
          <button
            onClick={() => { setOpen(false); onAiPosts(); }}
            disabled={aiPosting}
            className="w-full flex items-center gap-2 px-4 py-2.5 text-fuchsia-400 hover:bg-fuchsia-400/10 text-xs font-bold tracking-wider transition-colors text-left disabled:opacity-50"
          >
            {aiPosting ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Megaphone className="w-3.5 h-3.5" />} AI SOCIAL POSTS
          </button>
        </div>
      )}
    </div>
  );
}